// Copyright © 2021 Move Closer
import { clamp as _clamp } from '@vendors/clamp';
/**
 * Clamps the element's inner text to the specified number of lines.
 * Takes 3 as a fallback.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const clamp = {
    inserted(el, binding) {
        // Beware of the SSR.
        if (typeof window === 'undefined') {
            return;
        }
        let linesToClamp = 3;
        if (typeof binding.value === 'number') {
            linesToClamp = binding.value;
        }
        if (typeof binding.value === 'string') {
            linesToClamp = +binding.value;
        }
        try {
            _clamp(el, { clamp: linesToClamp });
        }
        catch (e) {
            console.error(e);
        }
    }
};
export default clamp;
